// src/services/transportClaimService.js
import ApiService from './api'

const TransportClaimService = {
  // Get all transport claims with pagination
  getAllTransportClaims: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString()
      const response = await ApiService.get(`/transport-claims${queryString ? `?${queryString}` : ''}`)
      return response
    } catch (error) {
      console.error('Error fetching transport claims:', error)
      throw error
    }
  },

  // Get transport claim by ID
  getTransportClaimById: async (id) => {
    try {
      const response = await ApiService.get(`/transport-claims/${id}`)
      return response
    } catch (error) {
      console.error('Error fetching transport claim:', error)
      throw error
    }
  },

  // Create transport claim
  createTransportClaim: async (data) => {
    try {
      const response = await ApiService.post('/transport-claims', data)
      return response
    } catch (error) {
      console.error('Error creating transport claim:', error)
      throw error
    }
  },

  // Update transport claim
  updateTransportClaim: async (id, data) => {
    try {
      const response = await ApiService.patch(`/transport-claims/${id}`, data)
      return response
    } catch (error) {
      console.error('Error updating transport claim:', error)
      throw error
    }
  },

  // Delete transport claim
  deleteTransportClaim: async (id) => {
    try {
      const response = await ApiService.delete(`/transport-claims/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting transport claim:', error)
      throw error
    }
  }
}

export default TransportClaimService
